import script from "./artmisadsSelectButton.vue?vue&type=script&setup=true&lang=js"
export * from "./artmisadsSelectButton.vue?vue&type=script&setup=true&lang=js"

import "./artmisadsSelectButton.vue?vue&type=style&index=0&id=bccfce4c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bccfce4c"]])

export default __exports__